const biayaWorkshopList = () => ({});
const biayaWorkshopDetail = () => ({});

// filter
const pagination = () => ({
    limit: 20,
    offset: 0,
    length: 0,
    pageNumber: 0,
});
const search = () => ({
    key: "",
});

const queryBiayaWorkshopList = () => ({});

const state = {
    biayaWorkshopList: biayaWorkshopList(),
    biayaWorkshopDetail: biayaWorkshopDetail(),

    // filter
    pagination: pagination(),
    search: search(),
    isSearch: false,

    // query
    queryBiayaWorkshopList: queryBiayaWorkshopList(),

    scrollPosition: 0,
};

export { state as default, biayaWorkshopList, biayaWorkshopDetail, pagination, search, queryBiayaWorkshopList };
